import type { MouseEventHandler, ReactNode } from 'react';
import type { HeaderColor } from '../Header/types';

export interface LocaleSwitcherData {
  parentColor: HeaderColor;
  onClick: MouseEventHandler;
  label: ReactNode;
  loading: boolean;
}

export interface LocaleSwitcherProps extends LocaleSwitcherData {}
